export default __webpack_public_path__ + "static/media/develtio_logo.3176bf3d.svg";